import { useStaticQuery, graphql } from "gatsby";
import { mergeCraftPreview, resolveImage } from "@dataResolvers";

const query = graphql`
  query DefaultsQuery {
    craft {
      globalSet(handle: "defaults") {
        ... on Craft_defaults_GlobalSet {
          metaTitle
          metaDescription
          metaImage {
            width
            height
            hasFocalPoint
            slug
            status
            title
            focalPoint
            url
          }
        }
      }
    }
  }
`;

const previewQuery = `query DefaultsQuery {
  craft {
    globalSet(handle: "defaults") {
      ... on Craft_defaults_GlobalSet {
        metaTitle
        metaDescription
          metaImage {
            width
            height
            hasFocalPoint
            slug
            status
            title
            focalPoint
            url
          }
      }
    }
  }
}`;

const dataResolver = ({ craft }) => {
  const { metaTitle, metaImage, metaDescription } = craft.globalSet;
  return {
    meta: {
      title: metaTitle,
      image: resolveImage(metaImage),
      description: metaDescription,
    },
  };
};

const useData = () => {
  const response = useStaticQuery(query);
  const data = mergeCraftPreview(response, previewQuery);
  return dataResolver(data);
};

export default useData;
